/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_fiat_v2/offer_service_show';
import 'stylesheets/showroom_fiat_v2/offer_service_show';
